/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {writeCustomerBio} from '../api'

export const useMutationWriteCustomerBio = createReactQueryMutationHook('writeCustomerBio', writeCustomerBio)
